// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const InternetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="InternetIcon" ref={forwardedRef} {...props}>
      <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m6.32-5.925h-2.878a12.7 12.7 0 0 0 .123-3.15h2.999a6.7 6.7 0 0 1-.244 3.15m-.619 1.35a6.67 6.67 0 0 1-3.807 2.951 12.6 12.6 0 0 0 1.249-2.951zm-3.63-1.35H7.93a11.4 11.4 0 0 1-.139-3.15h4.42a11.4 11.4 0 0 1-.139 3.15m-3.805 1.35h3.468a11.3 11.3 0 0 1-1.628 3.224H9.894a11.3 11.3 0 0 1-1.628-3.224m-1.708-1.35H3.68a6.64 6.64 0 0 1-.244-3.15h2.999a12.7 12.7 0 0 0 .123 3.15m-2.26 1.35h2.56a12.6 12.6 0 0 0 1.248 2.951A6.67 6.67 0 0 1 4.3 13.425m7.593-9.802a6.67 6.67 0 0 1 4.303 3.952h-2.817a12.7 12.7 0 0 0-1.486-3.952M10.105 3.35a11.3 11.3 0 0 1 1.893 4.224H8.002A11.3 11.3 0 0 1 9.895 3.35zM8.11 3.623a12.7 12.7 0 0 0-1.486 3.952H3.806a6.67 6.67 0 0 1 4.303-3.952" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const InternetIcon = /* @__PURE__ */ Object.assign(
  InternetIconComponent,
  { displayName: 'InternetIcon' },
);
